<template>
    <div id="inventory_transfer" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <!-- <span class="page-title" id="journalHeader" v-if="$route.params.id > 0">Update Journal</span> -->
                    <span class="page-title" id="journalHeader">Transfer Inventory</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backInventoryList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content inventory-transfer">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form journal-form" id="transferForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group mt-4" v-if="$route.params.id > 0">
                                        <label class="control-label" for="journal_number">Transfer Request #: </label>
                                        <span class="label font-bold">{{request_number}}</span>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="location_id">Sending Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Sending Warehouse:</label>
                                        <v-select v-model="warehouse_id" name="warehouse_id" placeholder="Select Warehouse."
                                                label="text"
                                                :options="warehouseArr" @input="changeWarehouse($event)">
                                        </v-select>
                                        <div class="field-error">{{warehouse_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Transfer Date</label>
                                        <div class="input-group">
                                            <template>
                                                <date-picker placeholder="MM/DD/YYYY" id="transfer_date" name="transfer_date" v-model="transfer_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="transfer_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </template>
                                        </div>
                                        <div class="field-error">{{transfer_date_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="location_id">Receiving Location:</label>
                                        <v-select v-model="receiving_location_id" name="receiving_location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{receivelocationerrors}}</div>
                                    </div> -->
                                     <div class="col form-group">
                                        <label class="control-label require" for="location_id">Receiving Warehouse:</label>
                                        <v-select v-model="receiving_warehouse_id" name="receiving_warehouse_id" placeholder="Select Warehouse."
                                                label="text"
                                                :options="warehouseArr" @input="tochangeWarehouse($event)">
                                        </v-select>
                                        <div class="field-error">{{receivewarehouserrors}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="jedescription">Notes:</label>
                                        <textarea class='form-control' v-model="notes" ref="notes" id="notes" rows="3"></textarea>
                                        <div class="field-error">{{notes_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:22%">Item</th>
                                                <th scope="col" >From R/S/B</th>
                                                <!-- <th scope="col" class="">From Bin</th>
                                                <th scope="col" class="">From Row</th> -->
                                                <th scope="col" class="require">To R/S/B</th>
                                                <!-- <th scope="col" class="">To Bin</th>
                                                <th scope="col" class="">To Row</th> -->
                                                <th scope="col" class="require">Quantity Sent</th>
                                                <th scope="col" class="require">Unit Cost</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                               <td>
                                                    <v-select v-model="row.item_id" name="item_id" id="item_id"
                                                            label="text" :filterable="false" :options="componentArr"
                                                            @search="onSearchComponent" @input="changeItem($event,index)"
                                                            placeholder="Select Item" class="custom-ci-auto-search contract-data">
                                                    <template slot="no-options">
                                                    Search Item...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                    </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.part_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <!-- <label class="control-label require" for="location_id">R/S/B:</label> -->
                                                    <v-select v-model="row.rsb_id" name="rsb_id" placeholder="R/S/B."
                                                            label="text"
                                                            :options="rsbArr" :disabled=true>
                                                    </v-select>
                                                    <div class="field-error">{{row.rsb_iderror}}</div>
                                                </td>
                                                <td>
                                                    <!-- <label class="control-label require" for="location_id">R/S/B:</label> -->
                                                    <v-select v-model="row.to_rsb_id" name="to_rsb_id" placeholder="R/S/B."
                                                            label="text"
                                                            :options="torsbArr">
                                                    </v-select>
                                                    <div class="field-error">{{row.to_rsb_iderror}}</div>
                                                </td>
                                                <!-- <td>
                                                    <input type="text" placeholder="From Shelf" :disabled="row.from_shelf != '' && row.from_shelf != null" v-model="row.from_shelf"  name="from_shelf" id="from_shelf" class="form-control">
                                                    <div class="field-error">{{row.from_shelf_error_msg}}</div>
                                                </td>
                                                 <td>
                                                    <input type="text" placeholder="From Bin" v-model="row.from_bin" :disabled="row.from_bin != '' && row.from_bin != null" name="from_bin" id="from_bin" class="form-control">
                                                    <div class="field-error">{{row.from_bin_error_msg}}</div>
                                                </td>
                                                 <td>
                                                    <input type="text" placeholder="From Row" v-model="row.from_row" :disabled="row.from_row != '' && row.from_row != null"  name="from_row" id="from_row" class="form-control">
                                                    <div class="field-error">{{row.from_row_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="To Shelf" v-model="row.to_shelf"  name="to_shelf" id="to_shelf" class="form-control">
                                                    <div class="field-error">{{row.to_shelf_error_msg}}</div>
                                                </td>
                                                 <td>
                                                    <input type="text" placeholder="To Bin" v-model="row.to_bin"  name="to_bin" id="to_bin" class="form-control">
                                                    <div class="field-error">{{row.to_bin_error_msg}}</div>
                                                </td>
                                                 <td>
                                                    <input type="text" placeholder="To Row" v-model="row.to_row"  name="to_row" id="to_row" class="form-control">
                                                    <div class="field-error">{{row.to_row_error_msg}}</div>
                                                </td>-->
                                                <td>
                                                    <input type="text" placeholder="0.00"  v-model="row.quantity" id="quantity" name="quantity" class="form-control text-right"  @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{row.quantity_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="0.00" v-model="row.unit_cost"  name="unit_cost" id="unit_cost" class="form-control text-right" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{row.unit_cost_error_msg}}</div>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="rows.length != 1">
                                                        <a href="javascript:void(0);" v-on:click="removeItem(index);"><i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>

                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="PostTransferBtn" class="btn btn-primary" v-on:click.prevent="postInventoryTransfer">
                                    <i class="fp-save"> </i>  Post
                                    </button>
                                    <router-link id="cancelTransferBtn" :to="'/inventory-transfer/list'" class="btn btn-tertiary">
                                          <i class="fp-close"> </i>  Cancel
                                    </router-link>
                                    <!-- <button type="submit" id="cancelTransferBtn" class="btn btn-tertiary" v-on:click.prevent="BackJournalsList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button> -->
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import moment from 'moment';
export default {
    name: "InventoryTransfer",
    metaInfo() {
        return {
            title:"Create Inventory Transfer | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        rows:[],
        transfer_date:"",
        transfer_date_error_msg:"",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        common_error_msg:"",
        notes:"",
        notes_error_msg:"",
        warehouse_id:'',
        // receiving_location_id:'',
        receiving_warehouse_id:'',
        locationArr:[],
        // location_error_msg:'',
        accountCanChanged:false,
        request_number:'',
        // receivelocationerrors:'',
        componentArr:[],
        receivewarehouserrors:'',
        warehouse_error_msg:'',
        rsbArr:[],
        warehouseArr:[],
        torsbArr:[],
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'make_transfer_request') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
   },
   created: function() {

   },
   mounted: function() {
        var self = this;
        self.getPermissions();
        self.generateRequestNumber();
        self.loadFieldData(['location','warehouse']);
        var path = window.location.pathname;
        var segments = path.split("/");

        self.status = {text:"Draft",value:"draft"};
        self.rows.push({
            item_id:0,
            part_error_msg:'',
            // from_shelf:"",
            // from_shelf_error_msg:"",
            // from_bin:"",
            // from_bin_error_msg:"",
            // from_row:"",
            // from_row_error_msg:"",
            // to_shelf:"",
            // to_shelf_error_msg:"",
            // to_bin:"",
            // to_bin_error_msg:"",
            // to_row:"",
            // to_row_error_msg:"",
            to_rsb_id:'',
            rsb_id:'',
            rsb_iderror:'',
            to_rsb_iderror:'',
            unit_cost:"",
            unit_cost_error_msg:"",
            quantity:0,
            quantity_error_msg:'',
        });
        var todayDate = self.getTodayDate();
        var postDate = moment(todayDate,"MM/DD/YYYY");
        self.transfer_date = postDate._i;

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                self.location_id = {
                    value: userObj["location_id"],
                    text: self.titleCase(userObj["locationName"]) + " | " + userObj["locationCode"]
                };
            }
        }
    },
    methods: {
        generateRequestNumber() {
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/request-number/generate",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                success: function (data) {

                    self.request_number = data.content;
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'journal-on-search-referance')
                }
            });

        },

        onSearchComponent(search, loading) {
            var self = this;
            if (search.length > 1) {
                // loading(true);
                if (self.warehouse_id != null && self.warehouse_id.value){

                    // self.searchField(loading, search, 'exist component', self.location_id.value);
                    self.searchField(loading, search, 'warehouse component', self.warehouse_id.value);

                }else{
                    self.location_error_msg = 'Please select location';

                }
            }
        },

        backInventoryList() {
            var self = this;
            self.$router.push("/inventory-transfer/list");
        },
        addRow: function () {
            var self = this;
            var index = self.rows.length-1;

            if (self.rows.length < 1) {

                self.rows.push({
                    item_id:0,
                    part_error_msg:'',
                    // from_shelf:"",
                    // from_shelf_error_msg:"",
                    // from_bin:"",
                    // from_bin_error_msg:"",
                    // from_row:"",
                    // from_row_error_msg:"",
                    // to_shelf:"",
                    // to_shelf_error_msg:"",
                    // to_bin:"",
                    // to_bin_error_msg:"",
                    // to_row:"",
                    // to_row_error_msg:"",
                    to_rsb_id:'',
                    rsb_id:'',
                    rsb_iderror:'',
                    to_rsb_iderror:'',
                    unit_cost:"",
                    unit_cost_error_msg:"",
                    quantity:0,
                    quantity_error_msg:'',
                });

            }else{
                // self.rows[index].from_shelf_error_msg = "";
                // self.rows[index].from_bin_error_msg = "";
                // self.rows[index].from_row_error_msg = "";
                // self.rows[index].to_shelf_error_msg = "";
                self.rows[index].rsb_iderror = "";
                self.rows[index].to_rsb_iderror = "";
                self.rows[index].unit_cost_error_msg = "";
                self.rows[index].quantity_error_msg = "";
                self.rows[index].part_error_msg = "";
                self.common_error_msg = "";

                if (self.rows[index].item_id != null && self.rows[index].item_id.value && self.warehouse_id != null
                    && self.warehouse_id.value && self.receiving_warehouse_id != null && self.receiving_warehouse_id.value && ( self.rows[index].quantity != null && self.rows[index].quantity != "" && self.rows[index].quantity > 0)) {
                    if (self.warehouse_id.value && self.receiving_warehouse_id.value && self.warehouse_id.value == self.receiving_warehouse_id.value){
                        if (self.rows[index].rsb_id != null && self.rows[index].rsb_id.value && self.rows[index].to_rsb_id != null && self.rows[index].to_rsb_id ) {

                        }else{
                            if (self.rows[index].rsb_id == null || !self.rows[index].rsb_id.value ) {
                                self.rows[index].rsb_iderror = "From R/S/B Required.";
                            }
                            if (self.rows[index].to_rsb_id == null || !self.rows[index].to_rsb_id ) {
                                self.rows[index].to_rsb_iderror = "To R/S/B Required.";
                            }
                            // if (self.rows[index].from_row == null || self.rows[index].from_row == "" ) {
                            //     self.rows[index].from_row_error_msg = "From Row Required.";
                            // }
                            // if (self.rows[index].to_shelf == null || self.rows[index].to_shelf == "" ) {
                            //     self.rows[index].to_shelf_error_msg = "To Shelf Required.";
                            // }
                            // if (self.rows[index].to_bin == null || self.rows[index].to_bin == "" ) {
                            //     self.rows[index].to_bin_error_msg = "To Bin Required.";
                            // }
                            // if (self.rows[index].to_row == null || self.rows[index].to_row == "" ) {
                            //     self.rows[index].to_row_error_msg = "To Row Required.";
                            // }
                            console.log('return if location same and shelf row bin not added');
                            return;
                        }
                    }
                    self.rows.push({
                        item_id:0,
                        part_error_msg:'',
                        // from_shelf:"",
                        // from_shelf_error_msg:"",
                        // from_bin:"",
                        // from_bin_error_msg:"",
                        // from_row:"",
                        // from_row_error_msg:"",
                        // to_shelf:"",
                        // to_shelf_error_msg:"",
                        // to_bin:"",
                        // to_bin_error_msg:"",
                        // to_row:"",
                        // to_row_error_msg:"",
                        to_rsb_id:'',
                        rsb_id:'',
                        rsb_iderror:'',
                        to_rsb_iderror:'',
                        unit_cost:"",
                        unit_cost_error_msg:"",
                        quantity:0,
                        quantity_error_msg:'',
                    });

                }else{

                    if ( self.rows[index].item_id == null || !self.rows[index].item_id.value ) {
                        self.rows[index].part_error_msg = "Item Require.";
                    }
                    if ( self.rows[index].quantity == 0 && self.rows[index].quantity == '' ) {
                        self.rows[index].quantity_error_msg = "Quantity Require.";
                    }
                    if (self.rows[index].unit_cost == null || self.rows[index].unit_cost == "" ) {
                        self.rows[index].unit_cost_error_msg = "Unit Cost Require.";
                    }
                    if (self.warehouse_id.value && self.receiving_warehouse_id.value && self.warehouse_id.value == self.receiving_warehouse_id.value){
                        if (self.rows[index].rsb_id != null && self.rows[index].rsb_id.value && self.rows[index].to_rsb_id != null && self.rows[index].to_rsb_id ) {

                        }else{
                            // if (self.rows[index].from_shelf == null || self.rows[index].from_shelf == "" ) {
                            //     self.rows[index].from_shelf_error_msg = "From Shelf Required.";
                            // }
                            // if (self.rows[index].from_bin == null || self.rows[index].from_bin == "" ) {
                            //     self.rows[index].from_bin_error_msg = "From Bin Required.";
                            // }
                            // if (self.rows[index].from_row == null || self.rows[index].from_row == "" ) {
                            //     self.rows[index].from_row_error_msg = "From Row Required.";
                            // }
                            // if (self.rows[index].to_shelf == null || self.rows[index].to_shelf == "" ) {
                            //     self.rows[index].to_shelf_error_msg = "To Shelf Required.";
                            // }
                            // if (self.rows[index].to_bin == null || self.rows[index].to_bin == "" ) {
                            //     self.rows[index].to_bin_error_msg = "To Bin Required.";
                            // }
                            // if (self.rows[index].to_row == null || self.rows[index].to_row == "" ) {
                            //     self.rows[index].to_row_error_msg = "To Row Required.";
                            // }
                            if (self.rows[index].rsb_id == null || !self.rows[index].rsb_id.value ) {
                                self.rows[index].rsb_iderror = "From R/S/B Required.";
                            }
                            if (self.rows[index].to_rsb_id == null || !self.rows[index].to_rsb_id ) {
                                self.rows[index].to_rsb_iderror = "To R/S/B Required.";
                            }
                            console.log('return if location same and shelf row bin not added');
                            return;
                        }
                    }
                }
            }
        },
        removeItem: function (index) {
            var self = this;
            if(self.rows.length > 1) {
                self.rows.splice(index, 1);
            }
        },
        isNumberCheck: function(evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        postInventoryTransfer(){
            var self = this;
            var error = false;
            self.receivewarehouserrors = "";
            self.transfer_date_error_msg = "";
            self.warehouse_error_msg = "";
            self.common_error_msg = "";
            self.notes_error_msg = "";


            if (!self.transfer_date || self.transfer_date == null || self.transfer_date == "") {
                self.transfer_date_error_msg = "Transfer Date Required.";
                error = true;
            }

            if (!self.warehouse_id || self.warehouse_id == null || !self.warehouse_id.value) {
                self.warehouse_error_msg = "Sending Warehouse Required.";
                error = true;
            }

            if (!self.receiving_warehouse_id || self.receiving_warehouse_id == null || !self.receiving_warehouse_id.value) {
                self.receivewarehouserrors = "Receiving Warehouse Required.";
                error = true;
            }

            if (self.rows.length < 1) {
                self.common_error_msg = "Items Required."
                error = true;
            }
            for(var i = 0;i<self.rows.length;i++) {
                self.rows[i].part_error_msg = "";
                // self.rows[i].from_shelf_error_msg = "";
                // self.rows[i].from_bin_error_msg = "";
                // self.rows[i].from_row_error_msg = "";
                // self.rows[i].to_shelf_error_msg = "";
                self.rows[i].rsb_iderror = "";
                self.rows[i].to_rsb_iderror = "";
                self.rows[i].unit_cost_error_msg = "";
                self.rows[i].quantity_error_msg = "";

                if ( self.rows[i].item_id == null || !self.rows[i].item_id.value ) {
                    self.rows[i].part_error_msg = "Item Require.";
                    error = true;
                }
                if ( self.rows[i].quantity == 0 && self.rows[i].quantity == '' ) {
                    self.rows[i].quantity_error_msg = "Quantity Require.";
                    error = true;
                }
                if (self.rows[i].unit_cost == null || self.rows[i].unit_cost == "" ) {
                    self.rows[i].unit_cost_error_msg = "Unit Cost Require.";
                    error = true;
                }
                if (self.rows[i].rsb_id == null || !self.rows[i].rsb_id.value ) {
                    self.rows[i].rsb_iderror = "From R/S/B Required.";
                    // error = true;
                }
                if (self.rows[i].to_rsb_id == null || !self.rows[i].to_rsb_id ) {
                    self.rows[i].to_rsb_iderror = "To R/S/B Required.";
                    error = true;
                }

                //  if (self.warehouse_id.value && self.receiving_warehouse_id.value && self.warehouse_id.value == self.receiving_warehouse_id.value){

                    // if (self.rows[i].from_shelf == null || self.rows[i].from_shelf == "" ) {
                    //     self.rows[i].from_shelf_error_msg = "From Shelf Required.";
                    //     error = true;
                    // }
                    // if (self.rows[i].from_bin == null || self.rows[i].from_bin == "" ) {
                    //     self.rows[i].from_bin_error_msg = "From Bin Required.";
                    //     error = true;
                    // }
                    // if (self.rows[i].from_row == null || self.rows[i].from_row == "" ) {
                    //     self.rows[i].from_row_error_msg = "From Row Required.";
                    //     error = true;
                    // }
                    // if (self.rows[i].to_shelf == null || self.rows[i].to_shelf == "" ) {
                    //     self.rows[i].to_shelf_error_msg = "To Shelf Required.";
                    //     error = true;
                    // }
                    // if (self.rows[i].to_bin == null || self.rows[i].to_bin == "" ) {
                    //     self.rows[i].to_bin_error_msg = "To Bin Required.";
                    //     error = true;
                    // }
                    // if (self.rows[i].to_row == null || self.rows[i].to_row == "" ) {
                    //     self.rows[i].to_row_error_msg = "To Row Required.";
                    //     error = true;
                    // }
                //     if (self.rows[i].rsb_id == null || !self.rows[i].rsb_id.value ) {
                //         self.rows[i].rsb_iderror = "From R/S/B Required.";
                //     }
                //     if (self.rows[i].to_rsb_id == null || !self.rows[i].to_rsb_id ) {
                //         self.rows[i].to_rsb_iderror = "To R/S/B Required.";
                //     }
                // }
            }

            if (!error) {
                self.loading = true;

                $("#PostTransferBtn").val("Posting ...");
                $("#PostTransferBtn").prop("disabled", true);
                $("#cancelTransferBtn").prop("disabled",true);

                var fields = $("#transferForm").serializeArray();
                if (self.warehouse_id != null && self.warehouse_id.value) {
                    fields.push({name: "warehouse_id", value: self.warehouse_id.value});
                }
                if (self.receiving_warehouse_id != null && self.receiving_warehouse_id.value) {
                    fields.push({name: "receiving_warehouse_id", value: self.receiving_warehouse_id.value});
                }
                if (self.warehouse_id != null && self.warehouse_id.location_id) {
                    fields.push({name: "location_id", value: self.warehouse_id.location_id});
                }
                if (self.receiving_warehouse_id != null && self.receiving_warehouse_id.location_id) {
                    fields.push({name: "receiving_location_id", value: self.receiving_warehouse_id.location_id});
                }
                fields.push({name: "request_number", value: self.request_number});
                fields.push({name: "transfer_date", value: self.transfer_date});
                fields.push({name: "notes", value:self.notes});

                fields.push({name: "transferItems", value: JSON.stringify(self.rows)});
                console.log(fields);

                $.ajax({
                    url: process.env.ROOT_API + "/inventory-transfer/request",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;

                        $("#PostTransferBtn").val("Post");
                        $("#PostTransferBtn").prop("disabled", false);
                        $("#cancelTransferBtn").prop("disabled",false);
                        if (data.code == 201) {
                            self.$swal('',data.content,'info');
                            return;
                        }

                        if (data.status == "success") {

                            self.$router.push("/inventory-transfer/list");

                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                setTimeout(function () {
                                    self.common_error_msg = "";
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        $("#PostTransferBtn").val("Post");
                        $("#PostTransferBtn").prop("disabled", false);
                        $("#cancelTransferBtn").prop("disabled",false);

                        self.generateStatusCodeMessage(jqXHR,true,'journal-create')
                    }
                });

            }else{
                self.errorValidationFocus();
            }
        },
        changeWarehouse:function(){
            var self = this;

            if (self.warehouse_id != null && self.warehouse_id.value){
                self.loadFieldData(['rsb'],self.warehouse_id.value);
            }
        },

        tochangeWarehouse:function(){
            var self = this;

            if (self.receiving_warehouse_id != null && self.receiving_warehouse_id.value){
                self.loadFieldData(['to_rsb'],self.receiving_warehouse_id.value);
            }
        },
        changeItem:function(evt,index){
            var self = this;
            self.rows[index].rsb_id= {text: evt.fromrsb, value: evt.bin_id};
            self.rows[index].unit_cost = evt.price;
            return;
            // if (self.warehouse_id == null || !self.warehouse_id.value){
            //     self.warehouse_error_msg = 'Warehouse Required';
            //     return;
            // }
            // $.ajax({
            //     url: process.env.ROOT_API + "/item-detail",
            //     type: "POST",
            //     data:{
            //         item_id:evt.value,
            //         warehouse_id:self.warehouse_id.value
            //     },
            //     headers: this.ajxHeaders,
            //     crossDomain: true,
            //     dataType:"json",
            //     success: function (data) {

            //         self.rows[index].from_shelf = data.content.location_shelf;
            //         self.rows[index].from_row = data.content.location_row;
            //         self.rows[index].from_bin = data.content.location_bin;
            //         self.rows[index].unit_cost = data.unit_cost;

            //         // self.request_number = data.content;
            //     },
            //     error: function (jqXHR, exception) {
            //         self.Registerbtn = "Register";
            //         self.generateStatusCodeMessage(jqXHR,true,'journal-on-search-referance')
            //     }
            // });
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/InventoryTransfer.vue